// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"199e6da2","207":"c29fab3d","213":"6b31146f","239":"99ddee8b","368":"436b8e99","453":"ae9c510e"}[chunkId] + ".chunk.js";
};